import React from 'react'
import classnames from 'classnames'
import { withStateHandlers } from 'recompose'
import styled from 'styled-components'

const ConfirmDeleteModal = ({
  children,
  isShow,
  onShow,
  onHide,
  onConfirm,
}) => (
  <React.Fragment>
    <div className={classnames('modal', { 'is-active': isShow })}>
      <div className="modal-background" />

      <ModalCard>
        <div className="card-content">
          <div className="content">
            <p className="title is-4">Are you sure?</p>
            <p className="subtitle is-5">This action cannot be undo.</p>
          </div>
        </div>
        <footer className="card-footer">
          <a onClick={onHide} className="card-footer-item">
            Cancel
          </a>
          <a onClick={onConfirm} className="card-footer-item">
            Delete
          </a>
        </footer>
      </ModalCard>
    </div>
    {children(onShow)}
  </React.Fragment>
)

const ModalCard = styled.div.attrs({ className: 'card' })`
  width: 300px;
`

const withConfirmModalHandlers = withStateHandlers(() => ({ isShow: false }), {
  onShow: () => () => ({ isShow: true }),
  onHide: () => () => ({ isShow: false }),
})

export default withConfirmModalHandlers(ConfirmDeleteModal)



// WEBPACK FOOTER //
// ./src/components/templates/deleteMoment/ConfirmDeleteModal.js